<template>
  <div class="content" :class="type" v-if="!(!show && type === 'shade')">
    <div class="list" @click="generationCourse" v-show="hasPermission('teacher_ai_chat')">
      <img src="@/assets/img/b_m.png" class="background" alt="" />
      <img src="@/assets/img/b_x.png" class="backgroundHover" alt="" />
      <img src="@/assets/img/icon_j.png" class="logo" alt="" />
      <span>{{ $t('courses.intelligentCourseGeneration') }}</span>
    </div>
    <div class="list" @click="create('create')">
      <img src="@/assets/img/b_m.png" class="background" alt="" />
      <img src="@/assets/img/b_x.png" class="backgroundHover" alt="" />
      <img src="@/assets/img/icon_j.png" class="logo" alt="" />
      <span>{{ $t('courses.newCourse') }}</span>
    </div>
    <div
      class="list"
      :class="isDragOver ? 'active' : ''"
      @dragover.prevent="handleDragOver"
      @dragleave="handleDragLeave"
      @drop.prevent="handleDrop"
    >
      <img src="@/assets/img/b_m.png" class="background" alt="" />
      <img src="@/assets/img/b_m@2x.png" class="background backgroundShade" alt="" />
      <img src="@/assets/img/b_x.png" class="backgroundHover" alt="" />
      <img src="@/assets/img/icon_d.png" class="logo" alt="" />
      <span>{{ $t('importCourse') }}</span>
      <div class="download" @click.stop="download">{{ $t('components.uploadModal.downloadTemplate') }}</div>
      <input type="file" @change="handleFileChange" accept=".xlsx, .xls" hidden ref="fileInput" />
      <div class="upload" @click="triggerFileInput"></div>
      <img class="close" @click="close" src="@/assets/img/icon_gb@2x.png" alt="" />
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'

export default {
  data() {
    return {
      show: false,
      isDragOver: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'content' // content | shade
    }
  },
  methods: {
    create(type) {
      this.$router.push({
        name: 'addCourses',
        query: {
          type
        }
      })
    },
    generationCourse() {
      this.$router.push({
        name: 'generationCourse'
      })
    },
    download() {
      // window.open('/static/xlsx/课程模版.xlsx')
      location.href = '/static/xlsx/课程模版.xlsx'
      this.$message.success('下载成功')
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      const file = event.target.files[0]
      this.processFile(file)
      event.target.value = ''
    },
    handleDragOver() {
      this.isDragOver = true
    },
    handleDragLeave() {
      this.isDragOver = false
    },
    handleDrop(event) {
      this.isDragOver = false
      const file = event.dataTransfer.files[0]
      this.processFile(file)
      event.target.value = ''
    },
    processFile(file) {
      if (!file) return

      const reader = new FileReader()

      reader.onload = e => {
        const data = new Uint8Array(e.target.result)
        let workbook
        try {
          workbook = XLSX.read(data, { type: 'array' })
        } catch (error) {
          this.$message.error('模板格式不正确，请检查')
        }

        // 假设读取第一个工作表
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]

        // 将工作表数据转换为 JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
        console.log(jsonData)

        // 设置表头和数据
        this.headers = jsonData[0] || []
        this.tableData = jsonData.slice(1)

        const sectionJson = []
        let lastSectionJson
        try {
          jsonData.forEach((item, index) => {
            if (index === 0) return
            if (item[0] && item[0] !== lastSectionJson?.name) {
              lastSectionJson = {
                name: item[0],
                children: item[1]
                  ? [
                      {
                        name: item[1]
                      }
                    ]
                  : []
              }
              sectionJson.push(lastSectionJson)
            } else {
              lastSectionJson.children.push({
                name: item[1]
              })
            }
          })
          console.log('导入成功', sectionJson)
          this.$store.commit('SET_BATCHLESSON', sectionJson)
          this.create('import')
        } catch (error) {
          this.$message.error('模板格式不正确，请检查')
        }
      }

      reader.readAsArrayBuffer(file)
    },
    close() {
      this.show = false
    },
    hasPermission(tag) {
      const permissionList = localStorage.permissionList || '[]'
      return permissionList && permissionList.includes(tag)
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
.content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-image: url('~@/assets/img/bj_first.png');
  background-size: 100% 100%;
  .list {
    width: 325px;
    height: 413px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    margin: 0 5%;
    .background,
    .backgroundHover {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
      opacity: 1;
    }
    .backgroundHover {
      opacity: 0;
    }
    .backgroundShade {
      display: none;
    }
    > * {
      position: relative;
      transition: all 0.6s;
    }
    .download {
      // font-weight: bold;
      font-size: 14px;
      color: #969ba7;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      position: absolute;
      top: 29px;
      right: 29px;
      z-index: 2;
    }
    .close {
      display: none;
    }
    .upload {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
    }
    .logo {
      width: 124px;
      height: 124px;
      margin-bottom: 54px;
    }
    span {
      color: #000;
      font-size: 16px;
      font-weight: 550;
      margin-top: 10px;
    }
    &:hover {
      .background {
        opacity: 0;
      }
      .backgroundHover {
        opacity: 1;
      }
      span {
        color: #ff6600;
      }
    }
  }
  .active {
    .background {
      opacity: 0;
    }
    .backgroundHover {
      opacity: 1;
    }
    span {
      color: #ff6600;
    }
  }
}
.shade {
  display: flex;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  .list:first-child {
    display: none;
  }
  .list:nth-child(2) {
    display: none;
  }
  .list {
    height: 375px;
    justify-content: flex-start;
    .logo {
      margin-top: 91px;
      margin-bottom: 22px;
    }
    .download {
      position: static;
      color: #515e7b;
      margin-top: 15px;
      line-height: 1;
    }
    > span {
      margin-top: 0;
      font-size: 18px;
    }
    .backgroundShade {
      display: block;
    }
    .close {
      display: block;
      position: absolute;
      top: 26px;
      right: 23px;
      cursor: pointer;
      width: 12px;
      height: 12px;
      z-index: 1;
    }
  }
}
</style>
